import axios from "axios";
import { base_url } from "../Global";
const API = axios.create({
  baseURL: base_url,
});

export default API;
